export const paths = {
  home: '/',
  reports: {
    workReport: '/reports/work',
    invoicingReport: '/reports/invoicing',
  },
  roles: '/roles',
};
